export const enum GeoSuraParamsEnum {
    APPLICATION_CODE = '141'
}